<script setup lang="ts">
import CheckoutTimeline from "@/shop/components/checkout/CheckoutTimeline.vue"
import { type ShippingMethod, useShopAppConfig } from "@/shop/composables"
import { useCartStore } from "@/shop/store/useCartStore"
import { $currency } from "@/vf"
import { computed } from "vue"
import { useRouter } from "vue-router"

const cartStore = useCartStore()
const { appConfig } = useShopAppConfig()
const router = useRouter()

// payment selection is a previous step and hasn't been completed, so navigate back
if (!cartStore.paymentMethod) {
    router.push({ name: "payment" })
}

function getShippingMethodPrice(method: ShippingMethod) {
    let price = undefined

    if (
        (appConfig.value.user.payType === "public_insurance" || appConfig.value.user.payType === "public_free") &&
        cartStore.containsLiquidItems
    ) {
        // Public-insurance patients only get free shipping when the cart contains liquids (the only
        // articles still covered by the Kostenträger) — mirrors ShippingCostService on the backend
        return 0
    }

    if (appConfig.value.user.payType === "berufsgenossenschaft" && cartStore.containsPrescriptionItems) {
        // The Berufsgenossenschaft covers flowers and liquids, so any prescription article
        // grants free shipping — mirrors ShippingCostService on the backend
        return 0
    }

    for (const minCartValue of Object.keys(method.prices)) {
        if (cartStore.totalPriceWithoutFees! >= parseInt(minCartValue)) {
            price = method.prices[minCartValue]
        }
    }

    return price
}

const availableShippingMethods = computed(() => {
    return appConfig.value.shippingMethods.filter(() => {
        // if (cartStore.paymentMethod === "offline") {
        //     // if payment method is offline, only pickup is allowed
        //     return shippingMethod.name === "pickup"
        // }

        return true
    })
})

function selectShippingMethod(method: ShippingMethod) {
    cartStore.shippingMethod = method.name

    router.push({ name: method.name === "pickup" ? "authorization" : "delivery-address" })
}
</script>

<template>
    <div class="container my-5">
        <div class="small text-muted mb-5 pb-3">Home / Warenkorb</div>

        <h2>Übersicht</h2>
        <div class="mb-3">
            <h1>Versand</h1>
        </div>

        <CheckoutTimeline :step="3" />
        <template v-for="method in availableShippingMethods" :key="method.name">
            <button class="wizard-button" @click="selectShippingMethod(method)">
                <div class="d-flex justify-content-between">
                    <b>{{ method.title }}</b>
                    <b>{{ $currency(getShippingMethodPrice(method)) }}</b>
                </div>
                <div class="small" v-html="method.subtitle"></div>
            </button>
        </template>
        <div class="mt-3 ml-3">
            * Originalrezept muss in der Apotheke vorliegen und die Zahlung zur Rechnung auf dem Konto der Apotheke
            eingegangen sein.
        </div>
    </div>
</template>
